import { PageBanner } from 'base/src/components/PageBanner';
import { PagamentoDestinoCard } from './components/PagamentoDestinoCard';
import { PagamentoDestino } from './components/PagamentoDestino';

import { removeResgate } from 'domain/store/_carteira/campanhaPedidoResgate/actions/campanhaPedidoResgateAction';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { useEffect, useState } from 'react';
import { PagarPremiacao } from '../../../store/_carteira/premiacao/actions/premiacaoAction';
import { PremiacaoService } from '../../../services/_carteira/premiacao/premiacaoService';
import SimpleBarReact from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

import * as S from './styles';
import { GetCarteiraBase } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { RootStateBaseCarteira } from '../../../store/_carteira/carteiraBaseReducer';

const connector = connectUtil(
  (state: RootStateBaseCarteira) => ({
    HomeInfo: state.CarteiraBaseReducer.CarteiraBase,
    PremiacoesPagar: state.CampanhaPedidoResgateReducer.formData,
    PagamentoErros: state.PremiacaoReducer.Errors,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
  }),
  { removeResgate, PagarPremiacao, GetCarteiraBase }
);

export interface PremiacaoComponentProps extends PropsFromRedux<typeof connector> {}

function Premiacao(props: PremiacaoComponentProps) {
  const [removingItems, setRemovingItems] = useState<number[]>([]);
  const [pixValidationResults, setPixValidationResults] = useState<{ [key: number]: boolean }>({});
  const [hasPixValidationErrors, setHasPixValidationErrors] = useState<boolean>(false);

  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const _PremiacaoService = new PremiacaoService();

  async function handleValidatePix() {
    const newResults: { [key: number]: boolean } = {};

    for (const item of props.PremiacoesPagar) {
      const request = { ChavePix: item._Usuario.ChavePix };

      try {
        const response = await _PremiacaoService.ValidarPix(request, 8);

        if (response && 'Valid' in response) {
          newResults[item.CampanhaPedidoResgateID] = response.Valid;
        } else {
          newResults[item.CampanhaPedidoResgateID] = false;
        }
      } catch (error) {
        newResults[item.CampanhaPedidoResgateID] = false;
      }
    }

    setPixValidationResults(newResults);
    setHasPixValidationErrors(Object.values(newResults).some(valid => !valid));
  }

  useEffect(() => {
    handleValidatePix();
  }, [props.PremiacoesPagar]);

  function handleRemove (id: number) {
    return ()=>{
      setRemovingItems(prev => [...prev, id]);
      props.removeResgate(id);
    }
  }

  function handleRealizarPagamento() {
    const resgateIds = props.PremiacoesPagar.map(item => ({ CampanhaPedidoResgateID: item.CampanhaPedidoResgateID }));

    props.PagarPremiacao(resgateIds, props.CarteiraUsuario[0].CarteiraID, () => {
      props.GetCarteiraBase(props.CarteiraUsuario[0].CarteiraID);
      setShowConfirmation(true)
    });
  }

  function handleBack()
  {
    window.history.back();
  }

  const totalPremiacao = props.PremiacoesPagar.reduce((acc, item) => {
    const valor = item?.Premiacao?.ValorMonetario ? parseFloat(item.Premiacao.ValorMonetario) : parseFloat(item.Premiacao.Valor);
    //const valor = item?.Premiacao?.ValorMonetario ? parseFloat(item.Premiacao.ValorMonetario) : 0;
    return acc + valor * item.Qtde;
  }, 0);

  if (showConfirmation) {
    return (
      <S.Container>
        <PageBanner title='Pagamento Enviado' subtile='Status do seu pagamento' />
        <S.ConfirmationContainer>
          <S.ConfirmationIcon>
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" />
              <path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </S.ConfirmationIcon>
          <S.ConfirmationTitle>Pagamento em Processamento</S.ConfirmationTitle>
          <S.ConfirmationMessage>
            O pagamento foi colocado na fila e será feito em instantes. Em caso de problemas, contate o suporte Gruppy.
          </S.ConfirmationMessage>
          <S.ConfirmationButton onClick={handleBack}>
            Voltar
          </S.ConfirmationButton>
        </S.ConfirmationContainer>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <PageBanner title='Realizar Pagamento' subtile='Valide e confirme o pagamento' />
      <S.ContentWrapper>
        <S.DepositContainer>
          {props.PremiacoesPagar ? (
            <S.Options>
              <SimpleBarReact style={{ height: '100%' }} >
                {props.PremiacoesPagar.map(i => (
                  <PagamentoDestinoCard
                    key={i.CampanhaPedidoResgateID}
                    nome={i._Usuario.NomeCompleto}
                    isRemoving={removingItems.includes(i.CampanhaPedidoResgateID)}
                    remove={handleRemove(i.CampanhaPedidoResgateID)}
                    avatarUrl={i._Usuario.ImagemUrl}
                    cpf={i._Usuario.CPF}
                    email={i._Usuario.Email}
                    pix={i._Usuario.ChavePix}
                    premiacao={i.Premiacao.Titulo}
                    valor={Number(i.Premiacao.ValorMonetario ?? i.Premiacao.Valor) * i.Qtde}
                    validPix={pixValidationResults[i.CampanhaPedidoResgateID]}
                  />
                ))}
              </SimpleBarReact>
            </S.Options>
          ) : <></>}
        </S.DepositContainer>
        <S.Pagamanto>
          <PagamentoDestino
            valor={totalPremiacao}
            taxas={(~~props.PremiacoesPagar?.length) * props.HomeInfo.TaxaPagamento}
            realizarPagamento={handleRealizarPagamento}
            pixComErro={!hasPixValidationErrors}
          />
        </S.Pagamanto>
      </S.ContentWrapper>
    </S.Container>
  )
}


export default connector(Premiacao);